import { GrowthPerformance } from "./applications/analytics/executive/GrowthPerformance/GrowthPerformance";
import { ComparativeSales } from "./applications/analytics/executive/ComparativeSales/ComparativeSales";
import { ComparativeSalesPerformance } from "./applications/analytics/executive/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { PerformanceByProductGroup } from "./applications/analytics/executive/PerformanceByProductGroup/PerformanceByProductGroup";
import { CustomerSales } from "./applications/analytics/executive/CustomerSales/CustomerSales";
import { CustomerGroupProduct } from "./applications/analytics/executive/CustomerGroupProduct/CustomerGroupProduct";

// Region dashboard when the user login is Executive
import { ExecutiveRegionComparativeSalesPerf } from "./applications/analytics/executiveregion/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { ExecutiveRegionPerformanceByProductGroup } from "./applications/analytics/executiveregion/PerformanceByProductGroup/PerformanceByProductGroup";
import { ExecutiveRegionComparativeSales } from "./applications/analytics/executiveregion/ComparativeSales/ComparativeSales";
import { ExecutiveRegionGrowthPerformance } from "./applications/analytics/executiveregion/GrowthPerformance/GrowthPerformance";
import { ExecutiveRegionCustomerSales } from "./applications/analytics/executiveregion/CustomerSales/CustomerSales";
import { ExecutiveRegionalCustomerGroupProduct } from "./applications/analytics/executiveregion/CustomerGroupProduct/CustomerGroupProduct";

import { DistrictComparativeSalesPerf } from "./applications/analytics/district/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictPerformanceByProductGroup } from "./applications/analytics/district/PerformanceByProductGroup/PerformanceByProductGroup";
import { DistrictComparativeSales } from "./applications/analytics/district/ComparativeSales/ComparativeSales";
import { DistrictGrowthPerformance } from "./applications/analytics/district/GrowthPerformance/GrowthPerformance";
import { DistrictCustomerSales } from "./applications/analytics/district/CustomerSales/CustomerSales";
import { DistrictCustomerGroupProduct } from "./applications/analytics/district/CustomerGroupProduct/CustomerGroupProduct";

import { AgentComparativeSalesPerf } from "./applications/analytics/agent/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { AgentPerformanceByProductGroup } from "./applications/analytics/agent/PerformanceByProductGroup/PerformanceByProductGroup";
import { AgentComparativeSales } from "./applications/analytics/agent/ComparativeSales/ComparativeSales";
import { AgentGrowthPerformance } from "./applications/analytics/agent/GrowthPerformance/GrowthPerformance";
import { AgentCustomerSales } from "./applications/analytics/agent/CustomerSales/CustomerSales";
import { AgentCustomerGroupProduct } from "./applications/analytics/agent/CustomerGroupProduct/CustomerGroupProduct";

import { RegionComparativeSalesPerf } from "./applications/analytics/region/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { RegionPerformanceByProductGroup } from "./applications/analytics/region/PerformanceByProductGroup/PerformanceByProductGroup";
import { RegionComparativeSales } from "./applications/analytics/region/ComparativeSales/ComparativeSales";
import { RegionGrowthPerformance } from "./applications/analytics/region/GrowthPerformance/GrowthPerformance";
import { RegionCustomerSales } from "./applications/analytics/region/CustomerSales/CustomerSales";
import { RegionalCustomerGroupProduct } from "./applications/analytics/region/CustomerGroupProduct/CustomerGroupProduct";

import { DistributorComparativeSalesPerf } from "./applications/analytics/distributor/ComparativeSalesPerformance";

import { CustomerComparativeSalesPerf } from "./applications/analytics/customer/ComparativeSalesPerformance";

import { ItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { ProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { OPMIColorScheme } from "../themes/theme-opmi";

import { ApplicationBrand, MenuItems, ApplicationItems } from "../client-configuration";
import { ProductComparativeYOY } from "./applications/analytics/executive/ProductComparativeYoY/ProductComparativeYOY";
import { AttendanceReport } from "./applications/analytics/executive/CoverageReport/Attendance/AttendanceReport";
import { CallCoverageReport } from "./applications/analytics/executive/CoverageReport/CallCoverageSummary/CallCoverageReport";

const exportApplication = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    },
    {
      "id": 3,
      "name": "Performance by Product Group"
    },
    {
      "id": 4,
      "name": "Comparative Sales"
    },
    {
      "id": 7,
      "name": "Customer Group Product"
    },
    {
      "id": 5,
      "name": "Growth Performance"
    },
    {
      "id": 6,
      "name": "Customer Sales"
    }
  ]
}

const exportApplicationCustomer = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    }
  ]
}

const nullData = {

}

export const ExecutiveData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': ComparativeSalesPerformance,
  '3': PerformanceByProductGroup,
  '4': ComparativeSales,
  '5': GrowthPerformance,
  '6': CustomerSales,
  '7': CustomerGroupProduct,
  '8': ProductComparativeYOY,
  '9': AttendanceReport,
  '10': CallCoverageReport,
  'applicationdashboard': exportApplication,
  'colorScheme': OPMIColorScheme,
};

export const DistrictData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': DistrictComparativeSalesPerf,
  '3': DistrictPerformanceByProductGroup,
  '4': DistrictComparativeSales,
  '5': DistrictGrowthPerformance,
  '6': DistrictCustomerSales,
  '7': DistrictCustomerGroupProduct,
  'applicationdashboard': exportApplication,
  'colorScheme': OPMIColorScheme,
};

export const AgentData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': AgentComparativeSalesPerf,
  '3': AgentPerformanceByProductGroup,
  '4': AgentComparativeSales,
  '5': AgentGrowthPerformance,
  '6': AgentCustomerSales,
  '7': AgentCustomerGroupProduct,
  'applicationdashboard': exportApplication,
  'colorScheme': OPMIColorScheme,
};

export const ExecutiveRegionalData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': ExecutiveRegionComparativeSalesPerf,
  '3': ExecutiveRegionPerformanceByProductGroup,
  '4': ExecutiveRegionComparativeSales,
  '5': ExecutiveRegionGrowthPerformance,
  '6': ExecutiveRegionCustomerSales,
  '7': ExecutiveRegionalCustomerGroupProduct,
  'applicationdashboard': exportApplication,
  'colorScheme': OPMIColorScheme,
};

export const RegionalData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': RegionComparativeSalesPerf,
  '3': RegionPerformanceByProductGroup,
  '4': RegionComparativeSales,
  '5': RegionGrowthPerformance,
  '6': RegionCustomerSales,
  '7': RegionalCustomerGroupProduct,
  'applicationdashboard': exportApplication,
  'colorScheme': OPMIColorScheme,
};

export const DistributorData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': DistributorComparativeSalesPerf,
  '3': nullData,
  '4': nullData,
  '5': nullData,
  '6': nullData,
  '7': nullData,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const CustomerData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': CustomerComparativeSalesPerf,
  '3': nullData,
  '4': nullData,
  '5': nullData,
  '6': nullData,
  '7': nullData,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const AgentProductData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': AgentItemsComparativeSalesPerf,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const DistrictProductData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': DistrictItemsComparativeSalesPerf,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const ProductData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': ItemsComparativeSalesPerf,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const ProductGroupData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': ProductGroupComparativeSalesPerf,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const AgentProductGroupData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': AgentProductGroupComparativeSalesPerf,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const DistrictProductGroupData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': DistrictProductGroupComparativeSalesPerf,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
};

export const DefaultData = {
  'brand': ApplicationBrand,
  'application': ApplicationItems,
  '1': nullData,
  '3': nullData,
  '4': nullData,
  '5': nullData,
  '6': nullData,
  '7': nullData,
  'applicationdashboard': exportApplicationCustomer,
  'colorScheme': OPMIColorScheme,
  'sections': [],
  'palettes': [],
  'themes': []
};

function getDataByEndPoint(title) {
  return MenuItems[title] || null;
}


export { getDataByEndPoint };